import React from "react";

import {areaFormat} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const AreaCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{areaFormat(property.area)}</>;
};
import React from "react";

import {areaFormat} from "@pg-mono/string-utils";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";

export const AreaCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    return <>{areaFormat(property.area)}</>;
};
